// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthSlides-base__ThhKR{position:relative;width:var(--size-full);transition:var(--duration-slow);transition-property:height}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "AuthSlides-base__ThhKR"
};
export default ___CSS_LOADER_EXPORT___;
